<script setup lang="ts">
import { EntityListPage, type EntityConfig } from '@botto/core';
import { projectsStore, type Project } from '../api';
import { useCdpProjectContext } from '../composables/useCdpProjectContext';

const { selectProject, loadProjects } = useCdpProjectContext();

const statusOptions = [
  { value: 'active', text: 'Активный' },
  { value: 'archived', text: 'Архив' },
];

const config: EntityConfig<Project> = {
  title: 'Проект',
  titlePlural: 'Проекты',
  keyExpr: 'id',
  popupWidth: 480,
  columns: [
    { dataField: 'name', caption: 'Название' },
    { dataField: 'system_id', caption: 'System ID', width: 160 },
    { dataField: 'sender_name', caption: 'Sender', width: 140 },
    { dataField: 'status', caption: 'Статус', width: 120 },
    { dataField: 'created_at', caption: 'Создан', dataType: 'datetime', width: 180 },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'name', label: 'Название', required: true },
    { dataField: 'system_id', label: 'System ID', required: true },
    { dataField: 'sender_name', label: 'Sender name', required: true },
    {
      dataField: 'status',
      label: 'Статус',
      editorType: 'dxSelectBox',
      editorOptions: { items: statusOptions, displayExpr: 'text', valueExpr: 'value' },
      editOnly: true,
    },
  ],
};

function onRowClick(row: Project) {
  if (row.id) selectProject(row.id);
}

async function onUpdated() {
  await loadProjects();
}
</script>

<template>
  <div class="projects-page">
    <h2 class="projects-page__title">Проекты</h2>
    <p class="projects-page__hint">Клик по строке выбирает проект для остальных разделов CDP.</p>
    <EntityListPage
      :config="config"
      :store="projectsStore"
      :on-row-dbl-click="onRowClick"
      @updated="onUpdated"
      @created="onUpdated"
    />
  </div>
</template>

<style scoped>
.projects-page {
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  flex: 1;
}
.projects-page__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.projects-page__hint {
  margin: 0;
  font-size: 0.875rem;
  color: var(--dx-color-text-secondary, #666);
}
</style>
